import React, { useState, useEffect } from 'react';
import { T } from '../../../../src/Components/FeatureComponents/Response/Utils';
import ModalPane from '../ModalPane/ModalPane';
import Button from '../Buttons/Button/Button';
import { truthyOrFalsy } from '../../../../src/Utils/Contexts';
import { loadStateSession } from '../../FlyfishComponents/flyfishutils/utils';

interface Props {
	data: any;
	handleModalToggle: Function;
	clearSession: Function;
	flyFishChangesReq: boolean;
	restartSession: Function;
	cartExist?: boolean;
	hideMonacoCart?: Function;
	selectedTheme?: string;
}

export const SessionTimeout = (props: Props) => {
	let {
		sessionExpiryMessage,
		isAdvanceTimoutWarningEnabled,
		sessionExpiryWarningTimeInSecs,
		sessionExpiryWarningMessage,
		eB,
	} = props.data;

	let [sessionTimeoutState, setTimeoutState] = useState('warning');
	// let [timer, setTimer] = useState(sessionExpiryWarningTimeInSecs || 60);
	let [timer, setTimer] = useState(300);

	let sessionTime = sessionExpiryWarningTimeInSecs
		? sessionExpiryWarningTimeInSecs
		: 300;
	useEffect(() => {
		let timeout: ReturnType<typeof setTimeout>;

		if (truthyOrFalsy(isAdvanceTimoutWarningEnabled)) {
			timeout = setTimeout(() => {
				props.clearSession();
				setTimeoutState('expired');
			}, sessionTime * 1000);
			let interval = setInterval(() => {
				if (timer < 0) {
					clearInterval(interval);
				} else {
					setTimer((timer) => timer - 1);
				}
			}, 1000);
		} else {
			props.clearSession();
			props.restartSession();
			if (
				props.cartExist &&
				(props.selectedTheme === 'monaco' ||
					props.selectedTheme === 'E-commerce Chat')
			) {
				props.hideMonacoCart();
			}
			setTimeoutState('expired');
		}

		setTimeout(() => {
			var el = document.querySelector('.timout-wrapper button');
			el && (el as HTMLElement).focus();
		}, 100);
		return () => {
			timeout && clearTimeout(timeout);
		};
	}, []);

	let keepAlive = () => {
		fetch(`${window['BASE_URL']}/GenericChatBot/keepAlive`, {
			credentials: 'include',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				botId: eB,
				apiuser: loadStateSession(eB),
			}),
		})
			.then((data) => data.json())
			.then((response) => {
				if (response.status === 'success') {
					props.handleModalToggle('keepalive');
				}
			});
	};

	let formatTime = (timer) => {
		let seconds: string | number = Math.floor(timer % 60);
		let minute: string | number = Math.floor(timer / 60);
		seconds = seconds < 10 ? '0' + seconds : seconds;
		minute = minute < 10 ? '0' + minute : minute;
		return minute + ':' + seconds;
	};

	return (
		<ModalPane
			heading={
				sessionTimeoutState === 'warning' ? (
					<div className='timout-warning-wrapper'>
						<span
							className='body-text-2'
							style={{
								display: 'flex',
								justifyContent: 'center',
								textAlign: 'center',
								opacity: '0.8',
								marginBottom: '16px',
							}}
						>
							{props.data.flyFishChangesReq
								? 'Your chat session will expire soon. Do you wish to continue the chat?'
								: sessionExpiryWarningMessage}
						</span>
						<div
							style={{ display: 'flex', justifyContent: 'center' }}
							className='timer head-text-2'
						>
							{formatTime(timer)}
						</div>

						<Button
							variant='text'
							className='submit-btn continue button-text-1 '
							fullWidth={true}
							onClick={() => keepAlive()}
						>
							<T labelName='continueChatLabel' />
						</Button>
						{props.data.isInsideCampaign ? null : (
							<Button
								variant='text'
								className='submit-btn button-text-1'
								fullWidth={true}
								onClick={() => {
									props.handleModalToggle('clearSession');
								}}
							>
								<T labelName='exitChatLabel' />
							</Button>
						)}
					</div>
				) : (
					<div className='timout-wrapper' style={{ marginBottom: '-21px' }}>
						<span
							className='body-text-2'
							style={{
								marginBottom: '24px',
								opacity: '0.8',
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							{props.data.flyFishChangesReq
								? 'Your chat session has expired'
								: sessionExpiryMessage}
						</span>
						<Button
							className='submit-btn continue button-text-1'
							fullWidth={true}
							onClick={() => {
								props.handleModalToggle('clearSession', true);
							}}
						>
							<T labelName='startNewChatLabel' />
						</Button>
						{props.data.isInsideCampaign && !props.flyFishChangesReq ? null : (
							<Button
								variant='text'
								className='submit-btn button-text-1'
								fullWidth={true}
								onClick={() => {
									props.handleModalToggle('clearSession');
								}}
							>
								<T labelName='exitChatLabel' />
							</Button>
						)}
					</div>
				)
			}
		></ModalPane>
	);
};
